import i18n from 'i18next';
import en from './en.json';
import es from './es.json';
import pt from './pt.json';

export const NS = 'dashboards';

// Guard the registration so importing this module is safe in environments where
// the i18next singleton isn't initialized (e.g. the jest test runner). In the
// app, i18n is initialized before features load, so this always runs.
if (typeof i18n.addResourceBundle === 'function') {
  i18n.addResourceBundle('en', NS, en, true, true);
  i18n.addResourceBundle('es', NS, es, true, true);
  i18n.addResourceBundle('pt', NS, pt, true, true);
}

export { en, es, pt };
